import React, { useEffect, useState } from "react";
import { Avatar, Box, Button, CircularProgress, Stack } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import { useIntl } from "react-intl";
import RevaText from "components/common/RevaText";
import { playerInitials } from "./player-form-helpers";

const PlayerPhotoUpload = ({ player, onFileSelect, uploading = false, saveFirst = false }) => {
  const intl = useIntl();
  const [localPreview, setLocalPreview] = useState(null);
  const imageUrl = player?.profile_pic_url;

  useEffect(() => {
    if (!uploading) {
      setLocalPreview(null);
    }
  }, [imageUrl, uploading]);

  const handleChange = (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file || uploading) return;

    const reader = new FileReader();
    reader.onloadend = () => setLocalPreview(reader.result);
    reader.readAsDataURL(file);
    onFileSelect?.(file);
  };

  return (
    <Stack alignItems="center" spacing={1.5} sx={{ py: 1 }}>
      <Avatar
        src={localPreview || imageUrl || undefined}
        alt={player?.first_name || ""}
        sx={{
          width: 96,
          height: 96,
          bgcolor: "action.hover",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        {!localPreview && !imageUrl ? playerInitials(player) : null}
      </Avatar>
      <Box>
        <Button
          component="label"
          variant="outlined"
          size="small"
          startIcon={uploading ? <CircularProgress size={16} /> : <UploadIcon />}
          disabled={uploading}
        >
          {intl.formatMessage({ id: "gestion.players.uploadPhoto" })}
          <input hidden type="file" accept="image/jpeg,image/png,image/webp,image/gif" onChange={handleChange} />
        </Button>
      </Box>
      <RevaText variant="caption" color="text.secondary" textAlign="center">
        {intl.formatMessage({
          id: saveFirst ? "gestion.players.photoSaveFirst" : "gestion.players.photoHint",
        })}
      </RevaText>
    </Stack>
  );
};

export default PlayerPhotoUpload;
